module.exports = __webpack_public_path__ + "static/media/SDFSA_8-317w.ea67e175.webp";